import { render } from "./DataBusinessPage.vue?vue&type=template&id=29dfcecf"
import script from "./DataBusinessPage.vue?vue&type=script&lang=js"
export * from "./DataBusinessPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__